module.exports = __webpack_public_path__ + "img/fundu@2x.f9ca3aa.png";